export enum ObjetoDeAssignmentStatus {
  PUBLICADO = 'PUBLICADO',
  RASCUNHO = 'RASCUNHO',
}
